import React, { useCallback } from 'react';

import { components } from 'react-select';
import styled from 'styled-components';

import { OBJECTIVE_LEVEL_TAGS } from 'constants/ProjectConstants';
import theme from 'constants/theme';

import { DriverOption } from './ReactSelectCompOverrides';
import TagIcon from './TagIcon';
import { StyledSelectDropdown } from './styles';

const AVAILABLE_TAGS = {};

OBJECTIVE_LEVEL_TAGS.forEach((tag) => {
  AVAILABLE_TAGS[tag.value] = tag;
});

const ModalStyledSelectDropdown = styled(StyledSelectDropdown)`
  height: 40px;
  width: 90px;
`;
export const ObjectiveSingleValue = (props = {}) => {
  const { label, bgColor, value, icon: Icon } = props.data;
  return (
    <components.SingleValue {...props}>
      <div style={{ margin: '0 16px 0 8px', display: 'flex', alignItems: 'center' }}>
        <TagIcon tagId={value || undefined} />
      </div>
    </components.SingleValue>
  );
};

const ObjectiveLevelSelectionComp = ({
  isEditing = false,
  // selectedTag = null,
  objectiveLevel,
  onSelect = () => {},
  onCancel = () => {},
}) => {
  const onClickAway = useCallback(() => {
    onCancel();
  }, [onCancel]);

  const selectTagType = useCallback(
    (tagTypeId) => {
      onSelect(tagTypeId);
    },
    [onSelect]
  );

  return (
    <ModalStyledSelectDropdown
      isDisabled={!isEditing}
      isEditing={isEditing}
      options={OBJECTIVE_LEVEL_TAGS}
      onChange={onSelect}
      value={OBJECTIVE_LEVEL_TAGS.filter((opt) => opt.value === objectiveLevel)[0]}
      classNamePrefix="driver-select"
      placeholder="Level"
      components={{
        Option: DriverOption,
        SingleValue: ObjectiveSingleValue,
      }}
      menuPortalTarget={document.body}
      styles={{
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        menuList: (base) => ({
          ...base,
          position: 'fixed !important',
          backgroundColor: 'white',
          border: '1px solid #eaeaea',
          width: '150px',
          '.driver-select__option--is-selected': {
            backgroundColor: theme.palette.background.blue.light.v2,
          },
        }),
      }}
      defaultMenuIsOpen
      autoFocus
    />
  );
};

export default ObjectiveLevelSelectionComp;
